import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { BatchStudent } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const retrieveEducationalAdvisorStudents = createAsyncThunk<BatchStudent[], void, { extra: Partial<Dependencies> }>(
  "educationalAdvisor/retrieveEducationalAdvisorStudents",
  async (_, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.getStudents();
  },
);

export const resetRetrieveEducationalAdvisorStudents = createAction("educationalAdvisor/resetRetrieveEducationalAdvisorStudents");
